module.exports = __webpack_public_path__ + "img/902f787.jpg";